<template>
  <div class="main">
    <div class="curse-content">
      <div class="curse-tex">当前位置：首页>我的申报</div>
      <div class="flex justify-end">
        <a
          :href="$store.state.shzzuser.link"
          class="curse-btn"
          v-if="$store.state.shzzuser.link"
          >2025填报</a
        >
        <div class="curse-btn" v-if="end == 0" @click="to(`/formsub`)">
          添加项目
        </div>
      </div>
    </div>
    <div class="list-content">
      <el-steps finish-status="success">
        <el-step title="添加项目"></el-step>
        <el-step title="导出申报书"></el-step>
        <el-step title="签字盖章"></el-step>
        <el-step title="上传申报书（签字盖章版）"></el-step>
        <el-step title="提交申报"></el-step>
      </el-steps>

      <div class="search-box" v-if="this.user.id == 1">
        <div class="search-item">
          <el-input v-model="search.keyword" placeholder="关键词"></el-input>
        </div>
        <div class="search-item">
          <el-date-picker
            v-model="search.time"
            value-format="yyyy-MM-dd"
            end-placeholder="结束日期"
            range-separator="至"
            start-placeholder="开始日期"
            type="daterange"
            style="width: 100%"
          >
          </el-date-picker>
        </div>
        <div class="search-item">
          <el-select
            v-model="search.project_direction"
            placeholder="项目方向"
            :clearable="true"
            style="width: 100%"
          >
            <el-option
              v-for="item in directionTwo"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="search-item" style="flex: 1">
          <el-button type="primary" icon="el-icon-refresh" @click="searchreset">
            重置
          </el-button>
          <el-button type="primary" icon="el-icon-search" @click="searchFun">
            搜索
          </el-button>
        </div>
      </div>

      <div style="border: 1px solid #eceef0; margin: 20px 0 0 0"></div>
      <!--      approve_status 0 未提交 1 审核中 2 审核通过 3 审核驳回
      is_save 0 已提交 1 草稿-->

      <div class="item" v-for="item in list" :key="item.id">
        <div class="item-title ovHide">{{ item.project_name }}</div>
        <div class="item-time">{{ zhDate(item.create_time * 1000) }}</div>
        <div class="item-set">
          <div class="flex justify-start align-center">
            <!--            <div class="item-type grey" v-if="item.approve_status == 0">未提交</div>-->
            <!--            <div class="item-type blue" v-else>提交成功</div>-->
            <!--            <div class="item-type blue" v-if="item.approve_status == 1">提交成功</div>-->
            <div class="item-type red" v-if="item.approve_status == 3">
              初审未通过
            </div>
            <div class="item-type green" v-if="item.approve_status == 2">
              初审通过，成功入库
            </div>

            <a
              :href="item.organ_letter"
              target="_blank"
              v-if="item.organ_letter"
              class="item-look"
              >查看申报书</a
            >
            <!--            <a :href="item.implement_letter" target="_blank" v-if="item.implement_letter" class="item-look">查看意见书</a>-->
          </div>
          <div class="item-btnbox" v-if="end == 0">
            <router-link
              class="item-btn"
              :to="`/formSub?id=${item.id}`"
              v-if="item.approve_status != 1"
            >
              <i class="iconfont icon-redact"></i> 编辑
            </router-link>
            <div
              class="item-btn"
              @click="del(item.id)"
              v-if="item.approve_status == 0 || item.approve_status == 3"
            >
              <i class="iconfont icon-6shanchu-2"></i> 删除
            </div>
            <upload-file
              class=""
              name="organ_letter"
              accept=".pdf"
              v-if="item.approve_status == 0 || item.approve_status == 3"
              :params="item"
              auth
              @uploadFile="uploadFile"
            >
              <div class="item-btn" slot="upload">
                <i class="iconfont icon-shangchuan"></i> 上传pdf格式申报书
              </div>
            </upload-file>
            <upload-file
              class=""
              name="implement_letter"
              v-if="false"
              :params="item"
              auth
              @uploadFile="uploadFile"
            >
              <div class="item-btn" slot="upload">
                <i class="iconfont icon-shangchuan"></i> 上传意见书
              </div>
            </upload-file>
            <div
              class="item-btn"
              @click="exit(item.id)"
              v-if="item.approve_status == 1"
            >
              <i class="iconfont icon-withdraw-fill"></i> 撤回
            </div>
            <div
              class="item-btn"
              @click="sub(item.id)"
              v-if="item.approve_status == 0 && item.organ_letter"
            >
              <i class="iconfont icon-shenbao"></i> 提交申报
            </div>
          </div>
          <div v-else class="item-btnbox">
            <router-link class="item-btn" :to="`/formSub?id=${item.id}`">
              <i class="iconfont icon-redact"></i> 查看
            </router-link>
          </div>
        </div>
        <div class="item-feedback" v-if="item.approve_status == 3">
          驳回原因：<span>{{ item.refund_reason }}</span>
        </div>
      </div>
      <div class="page-box flex justify-center padding-top-sm">
        <el-pagination
          class="page-all margin-bottom"
          background
          @current-change="init"
          :current-page.sync="search.page"
          :page-size="search.limit"
          layout="prev, pager, next"
          :total="search.total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import {
  deleteProjectInfo,
  exitProjectApplication,
  getProjectApplicationList,
  save_organ_Letter,
  save_implement_letter,
  projectApprove,
  isEnd,
  getProjectClassLevelList,
} from "@/api/index";
import { zhDate } from "@/tools";
import UploadFile from "@/components/UploadFile";
import { baseURL } from "@/config";
export default {
  name: "index",
  data() {
    return {
      zhDate: zhDate,
      baseURL: baseURL,
      directionTwo: [],
      list: [],

      end: 0,
      search: {
        keyword: "",
        time: null,
        project_direction: "",
        page: 1,
        limit: 10,
        total: 20,
      },
    };
  },
  computed: {
    token() {
      return this.$store.state.shzztoken;
    },
    user() {
      return this.$store.state.shzzuser;
    },
  },
  components: { UploadFile },
  created() {
    this.$emit("setActive", {
      active: 0,
    });
    this.child();
    this.init();
    this.isEnd();
    /**
     if (!sessionStorage.getItem("tips")) {
      this.$alert(
        '<p>通知：</p><p style="text-indent: 28px">2026年社会组织服务社会示范项目申报工作已经结束。后续相关部门将对项目开展资质审核、立项支持评审等。需要进一步提供项目实施方案或参加项目评审会的，将电话联系。</p>',
        "温馨提示",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          callback: () => {
            sessionStorage.setItem("tips", 1);
          },
        },
      );
    }
     */
  },
  methods: {
    async isEnd() {
      let _data = await isEnd();
      if (_data.code === 200) {
        this.end = _data.data;
      }
    },

    uploadFile(data) {
      // this.ruleForm[data.name].push({
      //   name: data.file.name,
      //   href: data.file.url,
      // })
      if (data.name == "implement_letter") {
        this.save_implement_letter(data.data.id, data.file.url);
      } else {
        this.save_organ_Letter(data.data.id, data.file.url);
      }
    },
    async save_organ_Letter(id, url) {
      let _data = await save_organ_Letter(id, url);
      if (_data.code === 200) {
        this.$message.success("上传成功");
        this.init();
        this.sub(id);
      } else {
        this.$confirm(_data.message, "提示", {
          confirmButtonText: "去填报",
          cancelButtonText: "取消",
          type: "error",
        })
          .then(() => {
            this.$router.push({
              path: "/formsub",
              query: {
                id: id,
              },
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消",
            });
          });
        this.$message.error(_data.message);
      }
    },
    async save_implement_letter(id, url) {
      let _data = await save_implement_letter(id, url);
      if (_data.code === 200) {
        this.$message.success("上传成功");
        this.init();
      } else {
        this.$message.error(_data.message);
      }
    },

    sub(id) {
      this.$confirm("是否立即提交?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let _data = await projectApprove(id);
        if (_data.code === 200) {
          this.$message.success(_data.message);
          this.init();
        } else {
          this.$message.error(_data.message);
        }
      });
    },

    // 获取列表
    async init() {
      let _data = await getProjectApplicationList(
        this.search.keyword,
        this.search.time ? this.search.time[0] : "",
        this.search.time ? this.search.time[1] : "",
        this.search.project_direction,
        this.search.page,
        this.search.limit,
      );
      if (_data.code === 200) {
        this.list = _data.data.data;
        this.search.total = _data.data.total;
      } else {
        this.$message.error(_data.message);
      }
    },
    // 删除
    del(id) {
      this.$confirm("你确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let _data = await deleteProjectInfo(id);
        if (_data.code === 200) {
          this.$message.success(_data.message);
          this.init();
        } else {
          this.$message.error(_data.message);
        }
      });
    },

    // 撤回
    exit(id) {
      this.$confirm("你确定撤回吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let _data = await exitProjectApplication(id);
        if (_data.code === 200) {
          this.$message.success(_data.message);
          this.init();
        } else {
          this.$message.error(_data.message);
        }
      });
    },
    searchFun() {
      this.search.page = 1;
      this.init();
    },
    searchreset() {
      this.search = {
        keyword: "",
        time: null,
        project_direction: "",
      };
      this.$router.push(`/orghome/index`);
      this.search.page = 1;
      this.init();
    },

    // 项目方向层级列表
    async child() {
      let _data = await getProjectClassLevelList(1);
      this.directionTwo = _data.data;
      this.directionTwo.map((item) => {
        item.label = item.class_name;
        item.value = item.id;
      });
    },
    to(path) {
      this.$router.push(path);
    },
  },
  watch: {},
  filters: {},
};
</script>

<style scoped lang="scss">
.main {
  width: 100%;
  .search-box {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    padding-top: 30px;

    .search-item {
      width: 400px;
      padding-right: 20px;
      margin-bottom: 20px;
    }
  }
  .curse-content {
    width: 100%;
    padding-top: 20px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding-right: 15px;

    .curse-tex {
      font-size: 16px;
      color: #333333;
    }

    .curse-btn {
      display: block;
      width: 108px;
      height: 36px;
      background-color: #5298e2;
      border-radius: 10px;
      text-align: center;
      line-height: 36px;
      font-size: 16px;
      color: #ffffff;
      cursor: pointer;
      margin-left: 30px;
    }
  }

  .list-content {
    width: 100%;
    min-height: 500px;
    border: 1px solid #999999;
    background: #ffffff;
    border-radius: 20px;
    padding: 20px;
    margin-top: 15px;

    .item {
      width: 100%;
      padding: 20px 0;
      border-bottom: 1px solid #eceef0;
      .item-feedback {
        width: 100%;
        padding: 10px 15px;
        background-color: #f7f7f7;
        font-size: 14px;
        font-weight: bold;
        color: #ed3434;
        margin-top: 10px;
        span {
          color: #333333;
          font-weight: normal;
        }
      }
      .item-set {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .item-btnbox {
          flex: 1;
          margin-left: 50px;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          .item-btn {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            cursor: pointer;
            font-size: 14px;
            color: #333333;
            margin-left: 20px;
            i {
              font-size: 16px;
              color: #333333;
              margin-right: 4px;
            }
          }
        }
        .item-look {
          width: 100px;
          height: 28px;
          border-radius: 6px;
          text-align: center;
          line-height: 28px;
          font-size: 14px;
          background-image: linear-gradient(90deg, #0115a6 0%, #1546c5 100%);
          margin-left: 15px;
          cursor: pointer;
          color: #ffffff;
        }
        .item-type {
          //width: 72px;
          padding: 0 10px;
          height: 28px;
          border-radius: 6px;
          text-align: center;
          line-height: 28px;
          font-size: 14px;
          &.grey {
            color: #999999;
            background-color: #f3f3f3;
          }
          &.red {
            color: #eb1d1d;
            background-color: #ffeded;
          }
          &.green {
            color: #1ea735;
            background-color: #e9f8e5;
          }
          &.blue {
            color: #3381c3;
            background-color: #e5eff8;
          }
        }
      }
      .item-time {
        width: 100%;
        font-size: 14px;
        color: #999999;
        margin: 10px 0;
      }
      .item-title {
        width: 100%;
        font-size: 16px;
        color: #333333;
      }
    }
  }
}
</style>
